import { Table } from "@dev2_techwalnut/tw-react-crud-dashlite";
import moment from "moment";
import { Fragment } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const DispatchDetails = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const columns = [
        {
            accessor: "invoice_number",
            header: "Invoice Number",
        },
        {
            accessor: "dispatch_number",
            header: "Dispatch Number",
        },
        {
            accessor: "dispatch_date",
            header: "Dispatch Date",
            cell: (row) => (
                <>{moment(row?.dispatch_date).format("DD-MM-YYYY")}</>
            ),
        },
        {
            accessor: "dispatch_amount",
            header: "Dispatch Amount",
        },
    ];
    return (
        <Fragment>
            <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                    <div className="nk-block-head-content">
                        <h4 className="nk-block-title"> Dispatch Details </h4>
                    </div>
                    <button
                        className="btn btn-sm btn-secondary"
                        onClick={() => navigate(-1)}
                    >
                        Back
                    </button>
                </div>
            </div>
            <div className="row">
                <div className="col-lg-3 col-sm-12 m-2">
                    <strong>Sales Order</strong>:{" "}
                    {location.state?.salesOrderDetails?.so_number}
                </div>
                <div className="col-lg-3 col-sm-12 m-2">
                    <strong>Product Name</strong>:{" "}
                    {
                        location.state?.salesOrderDetails?.product_details
                            ?.product_name
                    }
                </div>
                <div className="col-lg-3 col-sm-12 m-2">
                    <strong>Client</strong>:{" "}
                    {location.state?.salesOrderDetails?.client_details?.name}
                </div>
                <div className="col-lg-3 col-sm-12 m-2">
                    <strong>Target Date</strong>:{" "}
                    {moment(
                        location.state?.salesOrderDetails?.target_date
                    ).format("DD-MM-YYYY")}
                </div>
                <div className="col-lg-3 col-sm-12 m-2">
                    <strong>Dispatch Location</strong>:{" "}
                    {location.state?.salesOrderDetails?.dispatch_location}
                </div>
                <div className="col-lg-3 col-sm-12 m-2">
                    <strong>Quantity to be produced</strong>:{" "}
                    {location.state?.salesOrderDetails?.quantity}
                </div>
                <div className="col-lg-3 col-sm-12 m-2">
                    <strong>Quantity produced</strong>:{" "}
                    {
                        location.state?.salesOrderDetails?.product_details
                            ?.quantity_produced
                    }
                </div>
                <div className="col-lg-3 col-sm-12 m-2">
                    <strong>Total Dispatched</strong>:{" "}
                    {location.state?.salesOrderDetails?.total_dispatched}
                </div>
            </div>
            <Table
                data={
                    location.state?.salesOrderDetails?.dispatched_orders || []
                }
                columns={columns}
                globalSearch={false}
                pagination={false}
                manualFilter={false}
                editRows={false}
                deleteRows={false}
                filterModal={false}
                selectRows={false}
            />
        </Fragment>
    );
};

export default DispatchDetails;
